import {GitPullRequestClosedIcon, GitPullRequestDraftIcon, GitPullRequestIcon} from '@primer/octicons-react'
import {ActionList, type ActionListItemProps, Truncate} from '@primer/react'

import type {AutocompletePullRequest} from '../../utils/copilot-chat-types'

interface PullRequestSuggestionProps extends ActionListItemProps {
  pullRequest: AutocompletePullRequest
}

export function PullRequestSuggestion({pullRequest, ...props}: PullRequestSuggestionProps) {
  return (
    <ActionList.Item {...props}>
      <ActionList.LeadingVisual>
        {pullRequest.state === 'draft' && <GitPullRequestDraftIcon className="fgColor-neutral" />}
        {pullRequest.state === 'open' && <GitPullRequestIcon className="fgColor-open" />}
        {pullRequest.state === 'closed' && <GitPullRequestClosedIcon className="fgColor-done" />}
      </ActionList.LeadingVisual>
      <Truncate title={pullRequest.title} maxWidth={350}>
        {pullRequest.title}
      </Truncate>
      <ActionList.Description>#{pullRequest.number}</ActionList.Description>
    </ActionList.Item>
  )
}

try{ PullRequestSuggestion.displayName ||= 'PullRequestSuggestion' } catch {}